<div style="display: inline-flex; width: 100%;">
  <h1 mat-dialog-title>{{title}}</h1>
</div>

<div mat-dialog-content style="overflow: auto;">
  <ng-content></ng-content>
</div>
<div mat-dialog-actions>
  @if (acceptButtonText) {
    <button mat-button (click)="accept()" [disabled]="!valid || disabled">
      <mat-icon>check</mat-icon> {{ acceptButtonText }}
    </button>
  }
  @if (showCancelButton) {
    <button mat-button (click)="cancel()" [disabled]="disabled">
      <mat-icon>close</mat-icon> Abbrechen
    </button>
  }
  <ng-content select="actionOnFooter"></ng-content>
</div>


